// 采购
import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['purchase'], // 为了获取基础路由
    };
};
let userInfo = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
export const purchaseToPathNameMap = {
    // 请购单 system-code: purchase-system
    purchase1010: ({ businessKey }) => commonFunc(`/pur/purchaseOrder/detail?id=${businessKey}`),
    // 采购方订单
    purchase1020: ({ businessKey }) => commonFunc(`/pur/purchaseOrder/detail?id=${businessKey}`),
    // 采购商-发货计划
    purchase1030: ({ businessKey }) => commonFunc(`/pur/arrivalPlan/detail?id=${businessKey}`),
    // 发货单详情
    purchase1040: ({ businessKey }, customProps) => commonFunc(`/sup/supplierDispatchBill/detail?id=${businessKey}`),
    // 收货单详情
    purchase1050: ({ businessKey }) => commonFunc(`/pur/godownEntry/detail?id=${businessKey}`),
    // 供应商-采购订单详情system-code: provider-system
    purchase1011: ({ businessKey }) => commonFunc(`/sup/customerOrder/detail?id=${businessKey}`),
    // 供应商-发货计划
    purchase1031: ({ businessKey }) => commonFunc(`/sup/shippingPlan/detail?id=${businessKey}`),
    // 供应商-发货单详情
    purchase1041: ({ businessKey }) => commonFunc(`/sup/supplierDispatchBill/detail?id=${businessKey}`),
    // 退货单
    purchase1060: ({ businessKey }) => commonFunc(`/pur/returnList/detail?id=${businessKey}`),
    // 供应商-退货订单详情
    purchase1061: ({ businessKey }) => commonFunc(`/sup/cusReturnNote/detail?id=${businessKey}`),
    // 出库单
    purchase1070: ({ businessKey }) => commonFunc(`/psi/stockOut/detail?id=${businessKey}`),
    // 调拨单
    purchase1080: ({ businessKey }) => commonFunc(`/psi/transferringOrder/detail?id=${businessKey}`),
    // 项目材料清单
    purchase1120: ({ businessKey }) => commonFunc(`/log/materialsLog?projectId=${businessKey}`),
};
